import { profileOutput, TRAINING_ROUTES, } from "@repo/contract/training";
import { exerciseKeys } from "../exercise/keys";
import { profileKeys } from "./keys";
import { readSection, sectionMutation, sectionOptions, writeSection, } from "./section";
/**
 * The athlete profile (`D114`, `D148`): date of birth, height, sex and the
 * lifestyle cards.
 *
 * `GET` answers `404 profile.not_found` before the intake has written one; it
 * arrives as the server's `ApiError` and the screen decides what it means.
 * A card `PUT`s the three required facts plus ONE optional field: an absent
 * optional key is "leave it as stored" on the server (`D129`), and an explicit
 * `null` clears it.
 */
const spec = {
    key: profileKeys.profile,
    name: "profile",
    output: profileOutput,
    path: TRAINING_ROUTES.profile,
};
/** `GET /me/profile`. */
export function fetchProfile(api, init) {
    return readSection(api, spec, init);
}
/** `PUT /me/profile` — replaces the whole section; answers what is now stored. */
export function putProfile(api, input) {
    return writeSection(api, spec, input);
}
export function profileOptions(api) {
    return sectionOptions(api, spec);
}
export function profileMutation(api) {
    const section = sectionMutation(api, spec);
    // The date of birth and the sex place the strength levels (`D208`).
    return {
        ...section,
        invalidates: [...(section.invalidates ?? []), exerciseKeys.strengthAll],
    };
}
//# sourceMappingURL=profile.js.map